module.exports = __webpack_public_path__ + "img/img2.c3499048.png";